import { CounterpartyConnectStatusRUEnum } from '~/src/models/enums/counterparty-connect-status.enum';
import type { OrganizationInterface } from '~/src/repositories/organizations/types/organizations.types';

export const checkStatusConnected = (agent: OrganizationInterface) => {
    return (
        CounterpartyConnectStatusRUEnum[agent?.connectingStatus] === CounterpartyConnectStatusRUEnum.CONNECTED
    );
};
